import type { Room } from "building-types/rooms/roomTypes";
import { RoomEnclosure } from "building-types/rooms/roomTypesEnum";
import { aabb2ByPolyLine2s, aabb2Center, aabb2XLength, aabb2YLength } from "geom/aabb2";
import type { Vec3 } from "geom/vec3";
import { REFRACTION_PROBE_SITE_LAYER } from "gfx/layerConstants";
import { buildExteriorLayers } from "./buildingGeometryTools";

export function refractionProbeSettingsForRoom(
  room: Room | undefined,
  isExteriorRoomOnWindow: boolean,
): { threeLayers: number[]; refractionProbePosition?: Vec3; refractionProbeHalfSize?: Vec3 } {
  const threeLayers: number[] = buildExteriorLayers();

  const towardsOutside =
    !room ||
    room.attributes.roomEnclosure === RoomEnclosure.EXTERIOR ||
    room.attributes.roomEnclosure === RoomEnclosure.NONE ||
    (isExteriorRoomOnWindow && room.attributes.roomEnclosure === RoomEnclosure.OPEN);
  if (towardsOutside) {
    threeLayers.push(REFRACTION_PROBE_SITE_LAYER);
    return { threeLayers };
  }

  const aabb = aabb2ByPolyLine2s([room.outline]);
  if (aabb) {
    const [cx, cy] = aabb2Center(aabb); // TODO: Move the center to inside the outline in case it is outside
    const z = room.level.floorElevation + room.level.topOfWall / 2;
    return {
      // Note that these will be unused if the material doesn't use a refraction probe.
      refractionProbePosition: [cx, cy, z],
      refractionProbeHalfSize: [aabb2XLength(aabb) * 0.55, aabb2YLength(aabb) * 0.55, room.level.topOfWall * 0.55],
      threeLayers,
    };
  }
  threeLayers.push(REFRACTION_PROBE_SITE_LAYER);
  return { threeLayers };
}
